import * as actions from './actions'
import firebase from 'firebase'
import * as openpgp from 'openpgp'
import { takeEvery, put, select, call } from 'redux-saga/effects'

async function storeNote(userId, note) {
  const newNoteRef = firebase
    .database()
    .ref('users/' + userId + '/notes')
    .push()
  await newNoteRef.set(note)
  return newNoteRef.key
}

function storeNoteUpdate(userId, noteId, note) {
  const noteRef = firebase
    .database()
    .ref('users/' + userId + '/notes/' + noteId)
  return noteRef.set(note)
}

function storeNoteDelete(userId, noteId) {
  const noteRef = firebase
    .database()
    .ref('users/' + userId + '/notes/' + noteId)
  return noteRef.remove()
}

async function encrypt(content, { pubKey }) {
  const encryptedContent = await openpgp.encrypt({
    data: content || '', // must be a string
    publicKeys: openpgp.key.readArmored(pubKey).keys
  })
  return encryptedContent.data
}

function* createNote({ payload: { title, content, userId } }) {
  try {
    const pubKey = yield select(state => state.crypto.keys.public)
    const encryptedTitle = yield encrypt(title, { pubKey })
    const encryptedContent = yield encrypt(content, { pubKey })
    const note = { title: encryptedTitle, content: encryptedContent }
    const noteId = yield storeNote(userId, note)
    yield put(actions.createNoteSuccess(noteId))
  } catch (err) {
    console.error(err)
    yield put(actions.createNoteError(err))
  }
}

function* updateNote({ payload: { noteId, title, content, userId } }) {
  try {
    const pubKey = yield select(state => state.crypto.keys.public)
    const encryptedTitle = yield encrypt(title, { pubKey })
    const encryptedContent = yield encrypt(content, { pubKey })
    const note = { title: encryptedTitle, content: encryptedContent }
    yield storeNoteUpdate(userId, noteId, note)
    yield put(actions.updateNoteSuccess())
  } catch (err) {
    console.error(err)
    yield put(actions.updateNoteError(err))
  }
}

function* deleteNote({ payload: { noteId, userId } }) {
  try {
    yield call(storeNoteDelete, userId, noteId)
    yield put(actions.deleteNoteSuccess(noteId))
  } catch (err) {
    console.error(err)
    yield put(actions.deleteNoteError(err))
  }
}

export default function*() {
  yield takeEvery(actions.createNote, createNote)
  yield takeEvery(actions.updateNote, updateNote)
  yield takeEvery(actions.deleteNote, deleteNote)
}



// WEBPACK FOOTER //
// ./src/services/note/sagas.js